export function messageType(message) {
  switch (true) {
    case message?.attachment_content_type?.includes("audio") ||
      (["application/mp4", "video/mp4"].includes(
        message?.attachment_content_type
      ) &&
        message?.body == "audio.mp3"):
      return "audio";
    case ["application/mp4", "video/mp4"].includes(
      message?.attachment_content_type
    ) && message?.body != "audio.mp3":
      return "video";
    case message?.attachment_content_type?.includes("image"):
      return "image";
    case !!message?.attachment_content_type:
      return "file";
    case message?.type === "component":
      return "component";
    default:
      "chat";
  }
}
